//region :: Imports ::
import MComponent from '../Component';
import {AuthenticationResult, EventMessage, EventType, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication} from '@azure/msal-browser';
import {MsalAuthenticationTemplate, MsalProvider} from '@azure/msal-react';
import {ReactElement} from 'react';
import {MNullable} from '../../Utils';
import MAuthConfiguration from './AuthConfiguration';

//endregion

/** */
type Props = {
    clientId: string;
    tenantId: string;
    logLevel: LogLevel;
    children: JSX.Element | JSX.Element[] | string;
}

/** */
class MAuthProvider extends MComponent<Props> {

    public static msalContext: IPublicClientApplication;
    private m_callbackId: MNullable<string>;
    private readonly m_clientApp: IPublicClientApplication;

    /** */
    public constructor(props: Props) {
        super(props);

        const configuration = MAuthConfiguration.create(props.clientId, props.tenantId, props.logLevel);
        this.m_callbackId = null;
        this.m_clientApp = new PublicClientApplication(configuration);
        MAuthProvider.msalContext = this.m_clientApp;

    }

    /** */
    public componentDidMount(): void {

        this.m_callbackId = this.m_clientApp.addEventCallback(async(event: EventMessage): Promise<void> => {

            switch(event.eventType) {

                case EventType.LOGIN_SUCCESS:
                    this.m_clientApp.setActiveAccount((event.payload as AuthenticationResult).account);
                    break;

                case EventType.LOGOUT_SUCCESS:
                    this.m_clientApp.setActiveAccount(null);
                    break;

            }

        });

    }

    /** */
    public componentWillUnmount(): void {

        if(this.m_callbackId !== null) {

            this.m_clientApp.removeEventCallback(this.m_callbackId);
            this.m_callbackId = null;

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <MsalProvider instance={this.m_clientApp}>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                    {this.props.children}
                </MsalAuthenticationTemplate>
            </MsalProvider>
        );

    }

}

export default MAuthProvider;
